module.exports = __webpack_public_path__ + "img/6.976f4b30.jpg";